import React, { useEffect, useState } from "react";
import WOW from 'wowjs';
import 'animate.css';
import img2 from "../Assets/Images/contactimg.jpg";
import Layout from "../Components/Layout";
// import { ToastContainer, toast } from "react-toastify";
import toast, { Toaster } from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ApiEndPoint, ApiToken } from "../Data/Api";
import { faGlobe, faHeadset, faInbox } from "@fortawesome/free-solid-svg-icons";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import axios from "axios";
const ContactusNew = ({ onLogout }) => {
    useEffect(() => {
    new WOW.WOW({
      live: false, // Disable live updates (improves performance)
    }).init();
  }, []);

  const baseurl = ApiEndPoint();
  const token = ApiToken();
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    subject: "",
    phnno: "",
    message: "",
  });
  const [error, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [isBooking, setIsBooking] = useState(false);
  function ValidEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  }

  const handleChange = (event) => {
    const { value, name } = event.target;

    if (name === "name") {
      const trimmedValue = value.trim();

      if (!trimmedValue) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please enter your name.",
        }));
      } else if (!/^[A-Za-z\s]{3,}$/.test(trimmedValue)) {
        setErrors((prev) => ({
          ...prev,
          [name]:
            "Name should be at least 3 letters and contain only alphabets.",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "email") {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please enter your emaill.",
        }));
      } else if (!ValidEmail(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please enter a valid email address.",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "subject") {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please enter a subject.",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "phnno") {
      const trimmedValue = value.trim();

      if (!trimmedValue) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please enter your phone number.",
        }));
      } else if (!/^\+?[0-9]{7,15}$/.test(trimmedValue)) {
        setErrors((prev) => ({
          ...prev,
          [name]:
            "Phone number should be 7–15 digits and may include + at the start.",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    if (name === "message") {
      if (!value.trim()) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please enter a message.",
        }));
      } else {
        setErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }

    setFormData((prevdata) => ({
      ...prevdata,
      [name]: value,
    }));
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const submitForm = async () => {
    const { name, email, subject, phnno, message } = formData;

    const phoneRegex = /^\+?[0-9]{7,15}$/;
    const nameRegex = /^[A-Za-z\s]{3,}$/;
    const newErrors = {};

    if (!name) {
      newErrors.name = "Please enter your name.";
    } else if (!nameRegex.test(name)) {
      newErrors.name =
        "Name should be at least 3 letters and contain only alphabets.";
    }

    if (!email) {
      newErrors.email = "Please enter your email.";
    } else if (!isValidEmail(email)) {
      newErrors.email = "Please enter a valid email.";
    }

    if (!subject) {
      newErrors.subject = "Please enter a subject.";
    }

    if (!phnno) {
      newErrors.phnno = "Please enter your phone number.";
    } else if (!phoneRegex.test(phnno)) {
      newErrors.phnno =
        "Phone number should be 7–15 digits and may include + at the start.";
    }

    if (!message) {
      newErrors.message = "Please enter a message.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Clear errors and submit
    setErrors({});
    setIsBooking(true);

    const data = {
      token: token,
      first_name: name,
      email: email,
      subject: subject,
      contact: phnno,
      message: message,
    };

    try {
      const response = await axios.post(
        `${baseurl}/api/mail_Check_HR_Contact_Us`,
        data
      );

      setIsBooking(false);

      if (response.data === "Success") {
        setFormData({
          email: "",
          name: "",
          subject: "",
          phnno: "",
          message: "",
        });

        setMessage("Your message has send seccessfully");
      } else {
        setMessage("Submission failed. Please try again.");
      }
    } catch (error) {
      setIsBooking(false);
      console.error(error);
      setMessage("An error occurred while submitting your request.");
    }
  };

  return (
    <>
      {/* <ToastContainer /> */}
      <Toaster
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          duration: 4000,
        }}
      />
      <Layout logout={onLogout}>
        <section className="pt-4 pt-md-5">
          <div className="container">
            <div className="row mb-5">
              <div className="col-xl-10 wow animate__animated animate__fadeInUp">
                <h3>
                  We’d love to hear from you! Whether you have questions,
                  feedback, or need support, feel free to reach out to us
                </h3>
                <p className="lead mb-0">Here’s how you can get in touch:</p>
              </div>
            </div>

            <div className="row g-4 wow animate__animated animate__fadeInUp">
              <div className="col-md-6 col-xl-4">
                <div className="card card-body shadow text-center align-items-center h-100">
                  <div className="icon-lg bg-info bg-opacity-10 text-info rounded-circle mb-2">
                    <i className="bi bi-headset fs-5">
                      <FontAwesomeIcon icon={faHeadset} />
                    </i>
                  </div>
                  <h5>Call us</h5>

                  <div className="d-grid gap-3 d-sm-block">
                    <a href="tel://+966509786777">
                      <button className="btn btn-sm btn-primary-soft">
                        <i className="bi bi-phone me-2"></i> 966 50 978 6777
                      </button>
                    </a>
                    {/* <a href="tel://+447309803307">
                      <button className="btn btn-sm btn-light">
                        <i className="bi bi-telephone me-2"></i>+44 7309 803307
                      </button>
                    </a> */}
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-xl-4">
                <div className="card card-body shadow text-center align-items-center h-100">
                  <div className="icon-lg bg-danger bg-opacity-10 text-danger rounded-circle mb-2">
                    <i className="bi bi-inboxes-fill fs-5">
                      <FontAwesomeIcon icon={faInbox} />
                    </i>
                  </div>
                  <h5>Email us</h5>

                  <a
                    href="mailto:info@haramaynrooms.com"
                    className="btn btn-link text-decoration-underline p-0 mb-0"
                  >
                    <i className="bi bi-envelope me-1"></i>info@haramaynrooms.com
                  </a>
                </div>
              </div>

              <div className="col-md-6 col-xl-4">
                <div className="card card-body shadow text-center align-items-center h-100">
                  <div className="icon-lg bg-orange bg-opacity-10 text-orange rounded-circle mb-2">
                    <i className="bi bi-globe2 fs-5">
                      <FontAwesomeIcon icon={faGlobe} />
                    </i>
                  </div>
                  <h5>Address</h5>
                  <p className="p-0 mb-0 text-dark">
  <i className="bi bi-envelope me-1"></i>
  <a 
    href="https://www.google.com/maps?q=1a+Nansen+Road+Sparkhill+Birmingham+B11+4DR+UK" 
    target="_blank" 
    rel="noopener noreferrer"
    className="text-decoration-none text-dark"
  >
    1a Nansen Road Sparkhill Birmingham B11 4DR UK
  </a>
</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="pt-0 pt-lg-5">
          <div className="container">
            <div className="row g-4 g-lg-5 align-items-center">
              <div className="col-lg-6 text-center wow animate__animated animate__slideInLeft">
                <img style={{ width: "100%" }} src={img2} alt="image" />
              </div>

              <div className="col-lg-6 wow animate__animated animate__slideInRight">
                <div className="card bg-light p-4">
                  <div className="card-header bg-light p-0 pb-3">
                    <h3 className="mb-0">Send us message</h3>
                  </div>

                  <div className="card-body p-0">
                    <div className="row g-4 mt-2">
                      <div className="col-md-6">
                        <label className="form-label">Your name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Enter Name..."
                          name="name"
                          required
                        />

                        {error.name && (
                          <span className="text-danger">{error.name}</span>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Email address</label>
                        <input
                          type="email"
                          className="form-control"
                          onChange={handleChange}
                          value={formData.email}
                          placeholder="Email"
                          name="email"
                          required
                        />
                        {error.email && (
                          <span className="text-danger">{error.email}</span>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Subject</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.subject}
                          onChange={handleChange}
                          placeholder="Enter Subject..."
                          name="subject"
                          required
                        />
                        {error.subject && (
                          <span className="text-danger">{error.subject}</span>
                        )}
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Mobile number</label>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.phnno}
                          onChange={handleChange}
                          placeholder="+123456789"
                          name="phnno"
                          required
                        />
                        {error.phnno && (
                          <span className="text-danger">{error.phnno}</span>
                        )}
                      </div>
                      <div className="col-12">
                        <label className="form-label">Message</label>
                        <textarea
                          className="form-control"
                          placeholder="What’s on your mind"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          required
                        ></textarea>
                        {error.message && (
                          <span className="text-danger">{error.message}</span>
                        )}
                      </div>
                      <div className="col-12">
                        <button
                          type="submit"
                          disabled={isBooking}
                          onClick={submitForm}
                          className="btn btn-primary mb-0"
                        >
                          {" "}
                          {isBooking ? <Spinner /> : "Submit"}
                        </button>
                      </div>
                      {message && (
                        <span
                          className={`alert ${
                            message === "Your message has send seccessfully"
                              ? "alert-success text-success"
                              : "alert-danger text-danger"
                          }`}
                        >
                          {message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

const Spinner = () => {
  return (
    <div className="spinner-border" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );
};
export default ContactusNew;
